import axios from 'axios'
import { computed } from 'vue'

const URLS = {
    xhr: {
        mutate: {
            acceptDetailsUpdate: '/api/event/manage/accept-set-changes',
            rejectDetailsUpdate: '/api/event/manage/reject-set-changes',
            acceptPayoutUpdate: '/api/event/manage/accept-set-changes',
            rejectPayoutUpdate: '/api/event/manage/reject-set-changes'
        }
    }
}
export const useReviewSetData = (mode, emit, openModal, updateStep, eventId, venueId, artistId) => {
    const confirmEndpoint = computed(() => {
        switch (mode.value) {
            case 'details':
                return URLS.xhr.mutate.acceptDetailsUpdate
            case 'payout':
                return URLS.xhr.mutate.acceptPayoutUpdate
            default:
                return ''
        }
    })
    const acceptConfirmation = async () => {
        try {
            emit('loading', true)
            await axios.get(`${confirmEndpoint.value}/${eventId.value}/${artistId.value}`)
            emit('changes-accepted')
            updateStep('accept')
        } catch (error) {
            console.error(error)
        } finally {
            emit('loading', false)
        }
    }
    const rejectEndpoint = computed(() => {
        switch (mode.value) {
            case 'details':
                return URLS.xhr.mutate.rejectDetailsUpdate
            case 'payout':
                return URLS.xhr.mutate.rejectPayoutUpdate
            default:
                return ''
        }
    })
    const declineConfirmation = async () => {
        try {
            emit('loading', true)
            await axios.get(`${rejectEndpoint.value}/${eventId.value}/${artistId.value}`)
            openModal.value = false
        } catch (error) {
            console.error(error)
        } finally {
            emit('loading', false)
        }
    }

    const messageVenue = () => {
        sessionStorage.setItem('recipient_id', venueId.value)
        window.open('/profile/mail-chat', '_blank')
    }

    return {
        acceptConfirmation,
        declineConfirmation,
        messageVenue
    }
}
